
import { Component } from 'vue-property-decorator';

import Index from '@/views/mobile/Index.vue';

import { HotelsApi } from '@/api/HotelsApi';

import { MetaInfo } from 'vue-meta';

import { sortBy, first } from 'lodash';

@Component({
   metaInfo(): MetaInfo {
      return {
         title: 'Mobile - Hotels',
      };
   },
   filters: {
      room_type: (room_types: any[], id: number) => (room_types ? first(room_types.filter(a => a.d_id == id))?.d_name : ''),
      formatDate: (act_day: any) => (act_day != null ? new Date(act_day * 8.64e7).toISOString() : ''),
   },
})
export default class Hotels extends Index {
   accommodations: any = [];

   room_types: any = [];

   darkMode: boolean = false;

   dateRange: Date[] = [];

   fields: any[] = [
      {
         key: 'acс_checkin_date',
         sortable: true,
         label: 'Check-in Date',
      },
      {
         key: 'moto_lead_guest',
         sortable: true,
         label: 'Lead Guest',
      },
      {
         key: 'acс_supp_name',
         label: 'Accommodation',
      },
      {
         key: 'acс_number_rooms',
         label: 'Number of Rooms',
      },
      {
         key: 'acс_room_type_id',
         label: 'Room Type',
      },
      {
         key: 'acс_nts',
         label: 'Nights',
      },
   ];

   created(): void {
      this.darkMode = this.$localStorage.getItem('mobileDark');
   }

   mounted(): void {
      this.dateRange = [
         this.$moment()
            .subtract(2, 'days')
            .toDate(),
         this.$moment()
            .add(10, 'd')
            .toDate(),
      ];
      this.findOrders();
   }

   findOrders() {
      this.$store.commit('showLoading');

      this.$store.commit('setItems', { name: 'ready', value: false });
      Promise.all([
         HotelsApi.getAccommodationsDataByDate({
            dateFrom: this.$moment(this.dateRange[0]).format('YYYY-MM-DD'),
            dateTo: this.$moment(this.dateRange[1]).format('YYYY-MM-DD'),
            archive: 0,
         }),
         HotelsApi.accommodationsData(),
      ])
         .then((data: any[]) => {
            this.accommodations = sortBy(data[0]['Accommodation by date'], 'acс_checkin_date');
            this.room_types = data[1]['dic_room_type'];
         })
         .finally(() => {
            this.$store.commit('setItems', { name: 'ready', value: true });
            this.$store.commit('hideLoading');
         });
   }
}
